import {create} from 'zustand'
import { postPromotionType } from 'src/types/PromoType';

const today = new Date();

interface PromoResultState extends postPromotionType{
    setField: (field: keyof postPromotionType, value: any) => void 
    reset:()=>void;
}

export const usePromoresultStore = create<PromoResultState>((set)=>{
    const today = new Date()
    return{
        visit_date:today,
        school_id : 0,
        school_name: '',
        school_class: '',
        total_cnt : 0,
        attendee_cnt: 0,
        interested_cnt: 0,
        apply_cnt : 0,
        content : '',
        current_promotion :undefined,
        setField:(field,value)=>
            set((state)=>({...state,[field]:value})),
        reset:()=>
            set(()=>({
                visit_date:today,
                school_id : 0,
                school_class:'',
                total_cnt : 0,
                attendee_cnt: 0,
                interested_cnt: 0,
                apply_cnt : 0,
                content : '',
                school_name: '',
                current_promotion :undefined
            }))
    }
})

interface PromoAddInterestStore {
    promotion_id:number
    school_id : number;
    recent_date : Date | string;
    name : string;
    phone : string;
    birth_date : Date | string;
    gender : string;
    memo : string;
    school_class:string;
    interestData: any;
    type:string;
    major:string;
    setField: (field: keyof PromoAddInterestStore, value: any) => void 
    reset: ()=>void
}

const defaultValue = {
    promotion_id: 0,
    school_id : 0,
    recent_date : today.toString(),
    name : '',
    phone : '',
    birth_date : today.toString(),
    gender : '남자',
    memo : '',
    school_class : '',
    interestData:'',
    type:'관심',
    major:''
}

export const usePromoAddInterest = create<PromoAddInterestStore>((set)=>({
    ...defaultValue,
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    reset : ()=>set({...defaultValue})
}))

interface PromoDialogIntersetStore {
    isOpen : boolean,
    startBirth: Date | string | null;
    endBirth : Date | string | null;
    startCouncel : Date | string | null;
    endCouncel : Date | string | null;
    temp_startBirth: Date | string | null;
    temp_endBirth : Date | string | null;
    temp_startCouncel : Date | string | null;
    temp_endCouncel : Date | string | null;
    gender : number[]
    status : number[]
    temp_gender : number[]
    temp_status : number[]
    sort_by:string,
    sort_order:string,
    student_name:string,
    page:number;
    response:any[]
    total_rows:number;
    element:any;
    setField: (field: keyof PromoDialogIntersetStore, value: any) => void
    setResponse: (data: any, page?:number) => void;
    syncField: (field:keyof PromoDialogIntersetStore,to: "temp" | "base", from: "temp" | "base") => void;
    toggleFilter: (category: "temp_status" |"temp_gender", value: number, defaultValue: number) => void;
    reset: (isOpen?: boolean)=>void
    resetField: (field: keyof PromoDialogIntersetStore) => void;
}

const PromoDialogDefault={
    isOpen:false,
    startBirth: null,
    endBirth : null,
    startCouncel : null,
    endCouncel : null,
    temp_startBirth: null,
    temp_endBirth : null,
    temp_startCouncel : null,
    temp_endCouncel : null,
    gender : [0],
    status:[0],
    temp_gender : [0],
    temp_status:[0],
    sort_by: 'input_date',
    sort_order:'desc',
    student_name:'',
    page:1,
    response :[],
    total_rows:0,
    element:''
}

export const usePromoDialogInterest = create<PromoDialogIntersetStore>((set)=>({
    ...PromoDialogDefault,
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    setResponse: (data: any[], page = 1) =>
    set((state) => {
        if (page === 1) {
        return {
            response: data,
        };
        }
        return {
        response: [
        ...(state.response ?? []),
        ...data,
        ],
        };
    }),
    syncField: (field: string, to: "temp" | "base", from: "temp" | "base") =>
        set((state) => {
            const fieldMap: Record<string, [keyof PromoDialogIntersetStore, keyof PromoDialogIntersetStore]> = {
                gender: ["temp_gender", "gender"],
                status: ["temp_status", "status"],
            };

            const pair = fieldMap[field];
            if (!pair) {
            console.warn(`"${field}" is not a valid syncable field`);
            return {};
            }

            const [tempKey, baseKey] = pair;
            const toKey = to === "temp" ? tempKey : baseKey;
            const fromKey = from === "temp" ? tempKey : baseKey;

            return {
            [toKey]: state[fromKey],
            };
        }),
    toggleFilter : (category, value, defaultValue) =>
        set((state) => {
          const currentValues = state[category];
          let updatedValues;
    
          if (value === defaultValue) {
            // ✅ "전체"를 누르면 기존 값 제거하고 "전체"만 남김
            updatedValues = [defaultValue];
          } else {
            // 우선 "전체"(기본값)를 제거한 후
          const filteredValues = currentValues.filter((v) => v !== defaultValue);
    
          // 이미 선택된 값이면 제거, 없으면 추가
          if (filteredValues.includes(value)) {
            updatedValues = filteredValues.filter((v) => v !== value);
            // 모든 값이 제거되면 기본값으로 복원
            if (updatedValues.length === 0) updatedValues = [defaultValue];
          } else {
            updatedValues = [...filteredValues, value];
          }
          }
    
          let newState = { ...state, [category]: updatedValues };

          return newState;
        }),
    reset: (isOpen = false) => set({ ...PromoDialogDefault, isOpen: isOpen }),
    resetField: (field) => set((state) => ({...state,[field]: PromoDialogDefault[field as keyof typeof PromoDialogDefault]})),
}))